import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import '../styles/WatchDetailPage.css';
import { resolveWatchById } from '../utils/watchData';
import { withCropParams } from '../utils/imageUrl';

const WatchDetailPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [watch, setWatch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeImage, setActiveImage] = useState(0);
  
  useEffect(() => {
    window.scrollTo(0, 0);
    
    const fetchWatch = async () => {
      setLoading(true);
      try {
        console.log("Fetching watch details for ID:", id);
        const watchData = await resolveWatchById(id);
        
        if (watchData) {
          console.log("Watch found:", watchData.name);
          
          if (!watchData.specs) {
            watchData.specs = [
              { name: 'Kasa Malzemesi', value: 'Paslanmaz Çelik' },
              { name: 'Cam', value: 'Safir Cam' },
              { name: 'Su Dayanımı', value: '50m' },
              { name: 'Çap', value: '42mm' },
              { name: 'Kalınlık', value: '11mm' },
              { name: 'Hareket', value: 'Otomatik' },
              { name: 'Garanti', value: '2 Yıl Uluslararası' }
            ];
          }
          
          if (!watchData.images || !Array.isArray(watchData.images) || watchData.images.length === 0) {
            watchData.images = ['https://via.placeholder.com/800x800?text=No+Image'];
          }
          
          setWatch(watchData);
          setLoading(false);
          return;
        }

        setWatch(null);
        setError('Saat bulunamadı.');
        setLoading(false);
      } catch (err) {
        console.error("Error fetching watch details:", err);
        setError('Saat detayları yüklenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.');
        setLoading(false);
      }
    };
    
    fetchWatch();
  }, [id]);
  
  if (loading) {
    return (
      <div className="page watch-detail-page">
        <div className="container">
          <div className="loading-container">
            <div className="loading-spinner"></div>
          </div>
        </div>
      </div>
    );
  }
  
  if (error || !watch) {
    return (
      <div className="page watch-detail-page">
        <div className="container">
          <div className="error-message">
            {error || 'Saat bulunamadı.'}
          </div>
          <div className="back-link">
            <Link to="/">← Ana Sayfaya Dön</Link>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="page watch-detail-page">
      <div className="container">
        <div className="breadcrumbs">
          <Link to="/">Ana Sayfa</Link> / 
          <span>{watch.name}</span>
        </div>
        
        <div className="watch-detail-content">
          <div className="watch-images">
            <motion.div 
              className="main-image"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <img 
                src={withCropParams(watch.images[activeImage], 800)} 
                alt={watch.name} 
              />
            </motion.div>
            
            <div className="image-thumbnails">
              {watch.images.map((image, index) => (
                <div 
                  key={index}
                  className={`thumbnail ${activeImage === index ? 'active' : ''}`}
                  onClick={() => setActiveImage(index)}
                >
                  <img 
                    src={withCropParams(image, 100)} 
                    alt={`${watch.name} - ${index + 1}`} 
                  />
                </div>
              ))}
            </div>
          </div>
          
          <div className="watch-info">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              {watch.name}
            </motion.h1>
            
            <motion.div
              className="watch-price"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              {watch.price}
            </motion.div>
            
            <motion.div
              className="watch-description"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <p>{watch.description}</p>
            </motion.div>
            
            <motion.div
              className="contact-info"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <p>Satın almak veya detaylı bilgi almak için bize ulaşın:</p>
              <a 
                href="https://wa.me/905550236044" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="contact-button"
              >
                {t('whatsapp.contact')}
              </a>
              {watch.permalink && (
                <a
                  href={watch.permalink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-button instagram-detail-link"
                >
                  Instagram&apos;da görüntüle
                </a>
              )}
            </motion.div>
          </div>
        </div>
        
        <div className="watch-details-tabs">
          <div className="tabs">
            <div className="tab active">{t('watches.details.tab')}</div>
          </div>
          
          <div className="tab-content">
            <div className="tab-pane active">
              <div className="long-description">
                {watch.longDescription && watch.longDescription.trim()
                  ? watch.longDescription.split('\n\n').map((paragraph, idx) => (
                      <p key={idx}>{paragraph}</p>
                    ))
                  : <p>{watch.description}</p>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WatchDetailPage; 